import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['MeasurementDeviceModel'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasurementDeviceModelById: build.query<
        GetMeasurementDeviceModelByIdApiResponse,
        GetMeasurementDeviceModelByIdApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel/${queryArg}` }),
        providesTags: ['MeasurementDeviceModel'],
      }),
      deleteMeasurementDeviceModelById: build.mutation<
        DeleteMeasurementDeviceModelByIdApiResponse,
        DeleteMeasurementDeviceModelByIdApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['MeasurementDeviceModel'],
      }),
      getMeasurementDeviceModelGetAll: build.query<
        GetMeasurementDeviceModelGetAllApiResponse,
        GetMeasurementDeviceModelGetAllApiArg
      >({
        query: () => ({ url: `/MeasurementDeviceModel/get-all` }),
        providesTags: ['MeasurementDeviceModel'],
      }),
      getMeasurementDeviceModelByIdHasData: build.query<
        GetMeasurementDeviceModelByIdHasDataApiResponse,
        GetMeasurementDeviceModelByIdHasDataApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel/${queryArg}/has-data` }),
        providesTags: ['MeasurementDeviceModel'],
      }),
      getMeasurementDeviceModelByIdIsReferenced: build.query<
        GetMeasurementDeviceModelByIdIsReferencedApiResponse,
        GetMeasurementDeviceModelByIdIsReferencedApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel/${queryArg}/is-referenced` }),
        providesTags: ['MeasurementDeviceModel'],
      }),
      postMeasurementDeviceModel: build.mutation<
        PostMeasurementDeviceModelApiResponse,
        PostMeasurementDeviceModelApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel`, method: 'POST', body: queryArg }),
        invalidatesTags: ['MeasurementDeviceModel'],
      }),
      putMeasurementDeviceModel: build.mutation<PutMeasurementDeviceModelApiResponse, PutMeasurementDeviceModelApiArg>({
        query: (queryArg) => ({ url: `/MeasurementDeviceModel`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['MeasurementDeviceModel'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementDeviceModelApi };
export type GetMeasurementDeviceModelByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
export type GetMeasurementDeviceModelByIdApiArg = number;
export type DeleteMeasurementDeviceModelByIdApiResponse = unknown;
export type DeleteMeasurementDeviceModelByIdApiArg = number;
export type GetMeasurementDeviceModelGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
export type GetMeasurementDeviceModelGetAllApiArg = void;
export type GetMeasurementDeviceModelByIdHasDataApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementDeviceModelByIdHasDataApiArg = /** Measurement device model ID */ number;
export type GetMeasurementDeviceModelByIdIsReferencedApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementDeviceModelByIdIsReferencedApiArg = /** Measurement device model ID */ number;
export type PostMeasurementDeviceModelApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
export type PostMeasurementDeviceModelApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
export type PutMeasurementDeviceModelApiResponse = unknown;
export type PutMeasurementDeviceModelApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
export type ApiCommonExternalDtoMeasurementDeviceModelExternalDto = {
  id?: number;
  manufacturer: string;
  model: string;
  noiseThresholdVolt?: number | null;
  noiseThresholdAmpere?: number | null;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceModelExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementDeviceModelExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceModelExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementDeviceModelExternalDto;
};
export const {
  useGetMeasurementDeviceModelByIdQuery,
  useLazyGetMeasurementDeviceModelByIdQuery,
  useDeleteMeasurementDeviceModelByIdMutation,
  useGetMeasurementDeviceModelGetAllQuery,
  useLazyGetMeasurementDeviceModelGetAllQuery,
  useGetMeasurementDeviceModelByIdHasDataQuery,
  useLazyGetMeasurementDeviceModelByIdHasDataQuery,
  useGetMeasurementDeviceModelByIdIsReferencedQuery,
  useLazyGetMeasurementDeviceModelByIdIsReferencedQuery,
  usePostMeasurementDeviceModelMutation,
  usePutMeasurementDeviceModelMutation,
} = injectedRtkApi;
